import { useEffect } from 'react';

const useConsole = (...params: any[]) => {
  
  useEffect(() => {
    if (params) {
      console.log(...params);
    }
  }, [JSON.stringify(params)]);

  return null;
};

export default useConsole;
